import { emailSymbolList, letterOrders, numpad, numpadOnly, symbolList } from './Layouts';
import { defaultOptions } from './defaultOptions';
import { Key as BaseKey } from '@lightningjs/ui';
import { IconKey } from './IconKey';
import { Log } from '@lightningjs/sdk';

/**
 *
 * @param opt  see defaultOptions.js for example
 */

export function generateConfig(opt = {}) {
  let options = {
    ...defaultOptions,
    layoutOptions: {
      ...defaultOptions.layoutOptions,
      ...opt.layoutOptions,
    },
    styling: {
      ...defaultOptions.styling,
      ...opt.styling,
    },
    keyOptions: {
      ...defaultOptions.keyOptions,
      ...opt.keyOptions,
    },
    Space: {
      ...opt.Space,
    },
  };
  let config = {};

  config['layouts'] = getLayouts(options);

  config['styling'] = options.styling;
  config['buttonTypes'] = getButtonTypes(options);
  return config;
}

function getLayouts({
  layoutOptions: {
    layout,
    capsButton,
    columns,
    pyramid,
    symbolsColumns,
    symbolsPyramid,
    letters,
    numberPad,
    symbolPad,
    noSpacebar,
    noFinished,
    emailMode,
    numpadMode,
  },
}) {
  if (layout) {
    return layout;
  }

  if (numpadMode) {
    return { abc: numpadOnly };
  }

  let layouts = {};
  if (!letterOrders[letters]) {
    Log.error(`Letter order ${letters} does not exist`);
    return undefined;
  }

  let letterOrder = letterOrders[letters];

  if (emailMode) {
    letterOrder = letterOrder.concat(['@', '.', '_']);
  }
  let mainLayout = formatLetterOrder(letterOrder, columns, pyramid);

  let includeSpace = !noSpacebar && !letterOrder.includes('Space');
  let lastRow = [];
  if (capsButton) lastRow.push('Layout:ABC');
  if (numberPad) lastRow.push('Layout:123');
  if (includeSpace) lastRow.push('Space');
  if (symbolPad) lastRow.push('Layout:!@#');
  lastRow.push('Backspace');
  if (!noFinished) lastRow.push('Finished');
  if (lastRow.length > 0) {
    let lastRowFormatted = formatLetterOrder(lastRow, columns, pyramid);
    mainLayout = mainLayout.concat(lastRowFormatted);
  }

  layouts['abc'] = mainLayout;
  if (capsButton) {
    let uppercaseLetterOrder = letterOrder.map(letter => letter.toUpperCase());
    let uppercaseLayout = formatLetterOrder(uppercaseLetterOrder, columns, pyramid);
    let upperCaseLastRow = lastRow.map(item => (item === 'Layout:ABC' ? 'Layout:abc' : item));
    uppercaseLayout = uppercaseLayout.concat(formatLetterOrder(upperCaseLastRow, columns, pyramid));
    layouts['ABC'] = uppercaseLayout;
  }
  layouts['123'] = numpad;
  layouts['!@#'] = formatLetterOrder(
    !emailMode ? symbolList : emailSymbolList,
    symbolsColumns !== undefined ? symbolsColumns : columns,
    symbolsPyramid !== undefined ? symbolsPyramid : pyramid
  );

  return layouts;
}

function formatLetterOrder(letterOrder, columns, pyramid) {
  let idx = 0;
  let mainLayout = [];
  while (idx < letterOrder.length && columns > 0) {
    mainLayout.push(letterOrder.slice(idx, idx + columns));
    idx += columns;
    if (pyramid) columns -= 1;
  }
  if (columns === 0)
    Log.error('not enough space in letter pyramid for full keyboard. Change columns or turn off pyramid.');
  return mainLayout;
}

function getButtonTypes(options) {
  let keyOptions = options.keyOptions;
  if (keyOptions.buttonTypes) return keyOptions.buttonTypes;

  let defaultKeys = ['default', 'Layout', 'Space', 'Clear', 'Backspace', 'Finished'];
  let result = {};
  for (let i of defaultKeys) {
    result[i] = {
      type: BaseKey,
      w: keyOptions.w,
      h: keyOptions.h,
      label: {
        text: {
          ...keyOptions.label,
        },
      },
      backgroundColors: {
        ...keyOptions.backgroundColors,
      },
      labelColors: {
        ...keyOptions.labelColors,
      },
      ...options[i],
    };
  }

  result['Backspace'].type = IconKey;
  result['Backspace'].icon = 'images/keyboard/backspace_white.png'; //Utils.asset set in IconKey
  result['Finished'].type = IconKey;
  result['Finished'].icon = 'images/keyboard/checkmark_white.png';
  result['Space'].type = IconKey;
  result['Space'].icon = 'images/keyboard/spacebar_white.png';

  return result;
}
